<template>
	<div>
		<TextEditor :entity="form" label="Navn" alias="name" :validate="true" scope="contact"></TextEditor>

		<UserPicker :entity="form" label="Oprettet af" alias="owner" :values="$users" :validate="true" scope="contact"></UserPicker>
	</div>
</template>

<script>
import UserPicker from "../../_ui/editors/user";
import TextEditor from "../../_ui/editors/text";

export default {
	data: () => ({
		form: {
			name: null
		}
	}),
	components: { UserPicker, TextEditor },
	computed: {},
	watch: {},
	props: [],
	methods: {
		ok() {
			this.$validator.validate("contact.*").then(valid => {
				if (valid) {
					this.$http.put("/api/module/contacts", this.form).then(x => {
						this.$emit("close");

						this.$router.push("/contacts/" + x.data);
					});
				}
			})
		},
		cancel() {
			this.$emit("close");
		}
	},
	created() {},
	mounted() {},
};
</script>